import { api } from "services";

import { TABLE_TYPES } from "globals/constants/tableTypes";
import {
	store,
	storeAwardsActiveColumns,
	storeModificationsActiveColumns,
	storeProjectActiveColumns,
	storeProposalActiveColumns,
	storeSubawardModificationsActiveColumns,
	storeSubawardsActiveColumns,
	storeTasksActiveColumns,
} from "utils";
import {
	getAwardListAvailableColumns,
	getProjectListAvailableColumns,
	getProposalListAvailableColumns,
} from "utils/getColumnHeaders";
import { TASK_ACTIVE_COLUMN } from "../../globals/constants/task";

import { columns as constants } from "../constants";
import { dispatch } from "../store";

export const setAwardsActiveColumns = columns => {
	dispatch({ type: constants.AWARDS_SET_ACTIVE_COLS, columns });
	storeAwardsActiveColumns(columns);
};

export const setAwardsAvailableColumns = payload => {
	dispatch({
		type: constants.AWARDS_SET_AVAILABLE_COLS,
		payload: getAwardListAvailableColumns(payload),
	});
};

export const setProjectsActiveColumns = columns => {
	dispatch({ type: constants.PROJECTS_SET_ACTIVE_COLS, columns });
	storeProjectActiveColumns(columns);
};

export const setProjectsAvailableColumns = payload => {
	dispatch({
		type: constants.PROJECTS_SET_AVAILABLE_COLS,
		payload: getProjectListAvailableColumns(payload),
	});
};

export const setProposalsActiveColumns = columns => {
	dispatch({ type: constants.PROPOSALS_SET_ACTIVE_COLS, columns });
	storeProposalActiveColumns(columns);
};

export const setProposalsAvailableColumns = payload => {
	dispatch({
		type: constants.PROPOSALS_SET_AVAILABLE_COLS,
		payload: getProposalListAvailableColumns(payload),
	});
};

export const setSubawardsActiveColumns = columns => {
	dispatch({ type: constants.SUBAWARDS_SET_ACTIVE_COLS, columns });
	storeSubawardsActiveColumns(columns);
};

export const setModificationsActiveColumns = columns => {
	dispatch({ type: constants.MODIFICATIONS_SET_ACTIVE_COLS, columns });
	storeModificationsActiveColumns(columns);
};

export const setSubawardModificationsActiveColumns = columns => {
	dispatch({ type: constants.SUBAWARDS_MODIFICATIONS_SET_ACTIVE_COLS, columns });
	storeSubawardModificationsActiveColumns(columns);
};

export const loadTasksActiveColumns = () => async () => {
	const actionType = constants.TASKS_SET_ACTIVE_COLS;

	try {
		const data = await api.userColumnsPreferences.get(TABLE_TYPES.TASK);
		const defaultActiveColumns = store.getState().columns.tasks.defaultColumnHeaders
			.filter(header => header.active !== false);
		const activeColumns = data.activeColumns || defaultActiveColumns;
		const alwaysActiveColumns = TASK_ACTIVE_COLUMN.filter(header => header.alwaysActive);

		const activeColumnIds = new Set(activeColumns.map(col => col.id));
		const missingAlwaysActive = alwaysActiveColumns.filter(col => !activeColumnIds.has(col.id));
		const resultActiveColumns = [ ...missingAlwaysActive, ...activeColumns ];

		dispatch({ type: actionType, columns: resultActiveColumns });
		storeTasksActiveColumns(resultActiveColumns);

		return resultActiveColumns;
	} catch (error) {
		console.error("Error loading tasks active columns:", error);
	}
};

/**
 * Set active columns for tasks
 *
 * @param columns
 * @return {Promise<void>}
 */
export const setTasksActiveColumns = async columns => {
	const requestBody = {
		tableType: TABLE_TYPES.TASK,
		activeColumns: columns,
	};
	try {
		dispatch({ type: constants.TASKS_SET_ACTIVE_COLS, columns: columns });
		storeTasksActiveColumns(columns);
		await api.userColumnsPreferences.save(requestBody);
	} catch (error) {
		console.error("Error saving columns:", error);
	}
};

